import React from 'react';
import Input from './AuthInput';

import { ReactComponent as EyeOpenIcon } from '../../assets/icons/eye-open.svg';
import { ReactComponent as EyeClosedIcon } from '../../assets/icons/eye-closed.svg';

const AuthPasswordInput = ({onChange, placeholder, target, showWarning, value, label}) => {
  let [show, setShow] = React.useState(false);
  let [warning, setWarning] = React.useState(null);

  let icon = show ?
    <EyeClosedIcon className='icon sm action-icon eye-icon'
                   onClick={() => setShow(!show)}/> :
  <EyeOpenIcon className='icon sm action-icon eye-icon'
               onClick={() => setShow(!show)}/>;

  return (
    <Input type={show ? 'text' : 'password'}
           value={value}
           placeholder={placeholder}
           icon={icon}
           label={label}
           helperText={warning || ''}
           helperVariant={warning ? 'warning' : ''}
           onChange={(e) => {
             if (showWarning) {
               if (e.target.value.length < 8) {
                 setWarning('Password is less than 8 characters');
               }
               else if (!e.target.value.match(/[A-Z]/)) {
                 setWarning('Password does not contain an uppercase letter');
               }
               else if (!e.target.value.match(/[0-9]/)) {
                 setWarning('Password does not contain a number');
               }
               else if (target && e.target.value !== target) {
                 setWarning('Passwords do not match');
               }
               else {
                 setWarning(null);
               }
             }
             onChange(e);
           }}
    />
  );
}

export default AuthPasswordInput;
